import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import {
  Collapse,
  CardBody,
  Card,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Input,
} from "reactstrap";
import DatePicker from "react-date-picker";
import { connect } from "react-redux";
import $ from "jquery";
import "bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dropzone from "react-dropzone";
import SimpleReactValidator from "simple-react-validator";
import Spinner from "react-bootstrap/Spinner";
import * as moment from "moment";

toast.configure();
class pendingEdit extends Component {
  constructor(props) {
    super(props);
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var Referenceno = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.validator1 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_1 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_2 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator2_3 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator3 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator5 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator5_2 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.validator6 = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.state = {
      step1: "block",
      step2: "none",
      step3: "none",
      step4: "none",
      step5: "none",
      stepbarballon: 1,
      show: false,
      workflowid: "",
      value: new Date(),
      approverEdit: { status: false, value: "" },
      errorStatus: false,
      editAttachments: false,
      editReferences: false,
      getEmployeeFirstShow: false,
      AttachmentslistArray: [],
      sectionListArray: [],
      CompanylistArray: [],
      exitOptionList: [],
      DivisionListData: [],
      RequestlistArray: [],
      ActionTypelistArray: [],
      ReferenceLinkslistArray: [],
      ReferencesAdd: "none",
      attachmentdeletePopup: "",
      ReferencesAdd: "none",
      StaffDetailslistArraySpin: "none",
      attachmentdeleteid: "",
      editReferences_Reflink: "",
      editReferences_Remarks: "",
      editAttachments_Remarks: "",
      editAttachments_Sequenceno: "",
      editReferences_Sequenceno: "",
      referenceNo: Referenceno,
      loading: "",
      requesterId: 0,
      typeOfExit: 0,
      dateJoined: "",
      lastDayofService: "",
      phoneNumber: "",
      address: "",
      actionCategory: "",
      companycode: "",
      divisioncode: "",
      actionType: 0,
      employeeId: "",
      employeeName: "",
      eDocType: "",
      startDate: "",
      endDate: "",
      positionId: "",
      salaryGrade: "",
      workingGroup: "",
      additionalInformation: "",
      description: "",
      userId: "",
      section: "",
      division: "",
      department: "",
      designation: "",
      requesterName: "",
      eDocDisplay: false,
      actionDisplay: false,
      sequence_no: "",
      errorStatus: false,
      ApproverReferencesAdd: "none",
      ApproverShowReferenceRequired: "none",
      approverRequesterId: "",
      approverRequesterName: "",
      approverRequesterSection: "",
      approverRequesterSectionName: "",
      approverRequesterDepartment: "",
      approverRequesterDivision: "",
      approverRequesterDesignation: "",
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: "",
      approverRequesterDisplayName: "",
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      popupEmployeeName: "",
      popupEmployeeId: 0,
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
      referenceLinkList: [
        {
          reflink: "",
          remarks: "",
        },
      ],
      attachmentList: [
        {
          referenceNo: "",
          filename: "",
          filetype: "",
          remarks: "",
          userId: 0,
        },
      ],
      step1: true,
      step2: true,
      step3: true,
      step4: true,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevState.eDocType != this.state.eDocType &&
      this.state.eDocDisplay == false
    ) {
      this.RequestTypeListData();
      this.GetExitListData();
    }
    if (
      prevState.actionCategory != this.state.actionCategory &&
      this.state.actionDisplay == false
    ) {
      this.CompanyListData();
      this.DivisionListData();
      this.SectionListData();
      this.GetActionTypeListData();
    }
  };

  componentDidMount() {
    $("#StafNamePopover").popover({ html: true });
    this.props.dispatch({ type: "headerTitle", value: "Create Request" });
    this.props.dispatch({ type: "Referenceno", value: "" });
    this.geteDocRequest();
    this.getStaffName();
    this.CompanyListData();
    this.DivisionListData();
    this.SectionListData();
    this.GetExitListData();
    this.GetAttachmentslistData();
  }

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocDetails?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                referenceNo: data.resultObject.referenceNo,
                requesterId: data.resultObject.requesterId,
                typeOfExit: data.resultObject.typeOfExitName
                  ? data.resultObject.typeOfExitName
                  : 0,
                dateJoined: data.resultObject.dateJoined,
                lastDayofService: data.resultObject.lastDayofService,
                phoneNumber: data.resultObject.phoneNumber,
                address: data.resultObject.address,
                actionCategory: data.resultObject.actionCategory,
                companycode: data.resultObject.companycode,
                divisioncode: data.resultObject.divisioncode,
                actionType: data.resultObject.actionTypeName,
                employeeId: data.resultObject.employeeId,
                eDocType: data.resultObject.eDocType,
                employeeName: data.resultObject.employeeName,
                startDate: data.resultObject.startDate,
                endDate: data.resultObject.endDate,
                positionId: data.resultObject.positionId,
                salaryGrade: data.resultObject.salaryGrade,
                workingGroup: data.resultObject.workingGroup,
                additionalInformation: data.resultObject.additionalInformation,
                description: data.resultObject.description,
                userId: data.resultObject.userId,
                referenceLinkList: data.resultObject.referenceLinkList,
                attachmentList: data.resultObject.attachmentList,
                requesterName:
                  data.resultObject.requesterId +
                  " - " +
                  data.resultObject.requesterName,
                section: data.resultObject.section,
                department: data.resultObject.department,
                division: data.resultObject.division,
                designation: data.resultObject.designation,
                loading: "",
              });
              this.GetActionTypeListData(data.resultObject.actionCategory);
            }
            this.getStaffName(
              data.resultObject?.requesterId,
              data.resultObject?.requesterName
            );
            this.GetAttachmentslistData(data.resultObject?.referenceNo);
            this.GetReferenceLinkslistData(data.resultObject?.referenceNo);
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  getStaffName = (id, name) => {
    try {
      if (id) {
        let postData = {
          employeeId: id?.toString(),
          name: name,
          section: "",
          employeeType: "",
        };
        fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data?.resultObject) {
              this.setState({
                RequesterId: this.props.UserId,
                RequesterName: data.resultObject[0]?.name,
                RequesterSection: data.resultObject[0]?.section,
                RequesterSectionName: data.resultObject[0]?.sectionName,
                RequesterDepartment: data.resultObject[0]?.department,
                RequesterDivision: data.resultObject[0]?.division,
                RequesterDesignation: data.resultObject[0]?.designation,
                RequesterDisplayName:
                  this.props.UserId + " - " + data.resultObject[0]?.name,
                canStafNamePopover: "flex",
              });
              if (data.resultObject[0]?.employeeId) {
                this.getStaffDetails(
                  data.resultObject[0]?.employeeId,
                  data.resultObject[0]?.name,
                  data.resultObject[0]?.section,
                  data.resultObject[0]?.sectionName,
                  data.resultObject[0]?.department,
                  data.resultObject[0]?.division,
                  data.resultObject[0]?.designation,
                  data.resultObject[0]?.dateJoin
                );
              }
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  RequestTypeListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocTypeDropdown?UserId=${this.props.UserId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            let temp = [];
            data?.resultObject?.map(
              (dt) =>
                dt.eDocType == this.state.eDocType &&
                temp.push({
                  id: dt.eDocTypeId,
                  label: dt.eDocType,
                  value: dt.eDocType,
                })
            );
            this.setState({
              ...this.state,
              RequestlistArray: data?.resultObject,
              eDocType: temp[0],
              eDocDisplay: true,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  CompanyListData = () => {
    try {
      let postData = {
        companyNo: "",
        companyName: "",
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/CompanyCodeDropdown",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            let temp = [];
            data?.resultObject?.map((dt) => {
              if (dt.companyNo == this.state.companycode) {
                temp.push({
                  id: dt.companyNo,
                  label: dt.companyName,
                  value: dt.companyName,
                });
              }
            });
            if (temp?.length) {
              this.setState({
                ...this.state,
                CompanylistArray: data?.resultObject,
                companycode: temp[0],
              });
            } else {
              this.setState({
                ...this.state,
                CompanylistArray: data?.resultObject,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  DivisionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/eDoc/DivisionCodeDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            let temp = [];
            data.resultObject?.map((dt) => {
              if (dt.code == this.state.divisioncode) {
                temp.push({
                  id: dt.code,
                  value: dt.description,
                  label: dt.description,
                });
              }
            });
            if (temp.length > 0) {
              this.setState({
                ...this.state,
                DivisionListArray: data?.resultObject,
                divisioncode: temp[0],
              });
            } else {
              this.setState({
                ...this.state,
                DivisionListArray: data?.resultObject,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  SectionListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/SectionDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            this.setState({
              ...this.state,
              sectionListArray: data?.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetActionTypeListData = (value) => {
    try {
      if (value || this.state.actionCategory) {
        let postData = {
          id: 0,
          description: "",
          actioncategory: value ? value : this.state.actionCategory,
        };
        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/eDoc/ActionTypeDropDown",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data?.resultObject) {
              let temp = [];
              data.resultObject?.map(
                (dt) =>
                  dt.id == this.state.actionType &&
                  temp.push({
                    id: dt.id,
                    label: dt.description,
                    value: dt.description,
                  })
              );
              if (temp?.length > 0) {
                this.setState({
                  ...this.state,
                  ActionTypelistArray: data?.resultObject,
                  actionType: temp[0],
                  actionDisplay: true,
                });
              } else {
                this.setState({
                  ...this.state,
                  ActionTypelistArray: data?.resultObject,
                  actionDisplay: true,
                });
              }
            }
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  GetExitListData = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/TypeofExitDropdown",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            let temp = [];
            data.resultObject?.map(
              (dt) =>
                dt.id === this.state.typeOfExit &&
                temp.push({
                  id: dt.id,
                  label: dt.description,
                  value: dt.description,
                })
            );
            this.setState({
              ...this.state,
              exitOptionList: data?.resultObject,
              typeOfExit: temp[0],
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetAttachmentslistData = (value) => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetAttachments?ReferenceNo=${
            value ? value : this.state.referenceNo
          }`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              AttachmentslistArray: data.resultObject,
              AttachmentsLoader: "No",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  showFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: true });
  };

  approverShowFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: true });
  };

  approverHideFirstStaffPopup = () => {
    this.setState({ approverGetEmployeeFirstShow: false });
    this.setState({
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  approversearchEmployee = () => {
    try {
      this.setState({ approverStaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.approverpopupEmployeeId,
        name: this.state.approverpopupEmployeeName,
        section: this.state.approverpopupSection.value,
        employeeType: "",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ approverStaffDetailslistArray: data.resultObject });
            this.setState({ approverStaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approversearchEmployeeClear = () => {
    this.setState({
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  approverGetStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation
  ) => {
    this.setState({
      approverRequesterId: id,
      approverRequesterName: name,
      approverRequesterSection: section,
      approverRequesterSectionName: sectionName,
      approverRequesterDepartment: department,
      approverRequesterDivision: division,
      approverRequesterDesignation: designation,
      approverCanStafNamePopover: "flex",
      approverGetEmployeeFirstShow: false,
      approverRequesterDisplayName: id + " - " + name,
      approverpopupEmployeeId: "",
      approverpopupEmployeeName: "",
      approverpopupSection: 0,
      approverStaffDetailslistArray: [],
    });
  };

  hideFirstStaffPopup = () => {
    this.setState({ getEmployeeFirstShow: false });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      eDocType: 0,
      StaffDetailslistArray: [],
    });
  };

  showSecondAuthorizedNamePopup = () => {
    this.setState({ getAuthorizedNameSecondShow: true });
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      eDocType: 0,
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
      section: "",
    });
  };

  searchCompanyClear = () => {
    this.setState({
      popupCompanyNo: "",
      popupCompanyName: "",
      companylistArray: [],
    });
  };

  editAttachmentsShow = (Sequenceno, remarks) => {
    this.setState({
      editAttachments: true,
      editAttachments_Sequenceno: Sequenceno,
      editAttachments_Remarks: remarks,
    });
  };

  editAttachmentsHide = () => {
    this.setState({
      editAttachments: false,
      editAttachments_Sequenceno: "",
      editAttachments_Filename: "",
      editAttachments_Filetype: "",
      editAttachments_Remarks: "",
      editAttachments_URL: "",
    });
  };

  getStaffDetails = (
    id,
    name,
    section,
    sectionName,
    department,
    division,
    designation,
    dateJoin
  ) => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Dashboard/Employeedetails?EmployeeId=${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data?.resultObject) {
            //safik
            this.setState({
              RequesterId: id,
              phoneNumber: data?.resultObject.telno,
              address:
                data?.resultObject.address1 +
                data?.resultObject.address2 +
                data?.resultObject.address3 +
                data?.resultObject.address4,
              RequesterName: name,
              RequesterSection: section,
              RequesterSectionName: sectionName,
              RequesterDepartment: department,
              RequesterDivision: division,
              RequesterDesignation: designation,
              canStafNamePopover: "flex",
              getEmployeeFirstShow: false,
              RequesterDisplayName: id + " - " + name,
              popupEmployeeId: "",
              popupEmployeeName: "",
              popupSection: "",
              StaffDetailslistArray: [],
              dateJoin: dateJoin,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (error) {
      this.props.dispatch({ type: "Referenceno", value: "" });
      this.props.dispatch({ type: "UserId", value: "" });
      this.props.dispatch({ type: "profile", value: "" });
      this.props.dispatch({ type: "headerTitle", value: "" });
      this.props.dispatch({ type: "Token", value: "" });
      this.props.dispatch({ type: "userType", value: "" });
    }
  };

  cancelattachmentDelete = () => {
    this.setState({ attachmentdeletePopup: false, goodsItemdeleteid: "" });
  };

  deleteAttachment = (id) => {
    this.setState({ attachmentdeletePopup: true, attachmentdeleteid: id });
  };

  confirmattachmentDelete = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteAttachments?ReferenceNo=${
            this.state.referenceNo
          }&SequenceNo=${parseInt(this.state.attachmentdeleteid)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              attachmentdeleteid: "",
              attachmentdeletePopup: false,
            });
            this.GetAttachmentslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevState.requesterId !== this.state.requesterId) {
      if (this.state.requesterId != "") {
        this.getStaffName();
      }
    }
  }

  handleChange = (e) => {
    switch (e.target.name) {
      case "popupEmployeeId":
        this.setState({ ...this.state, popupEmployeeId: e.target.value });
        break;
      case "popupEmployeeName":
        this.setState({ ...this.state, popupEmployeeName: e.target.value });
        break;
      case "approverpopupEmployeeId":
        this.setState({
          ...this.state,
          approverpopupEmployeeId: e.target.value,
        });
        break;
      case "approverpopupEmployeeName":
        this.setState({
          ...this.state,
          approverpopupEmployeeName: e.target.value,
        });
        break;
      case "sequence_no":
        this.setState({ ...this.state, sequence_no: e.target.value });
        break;
      case "Single":
        this.setState({
          ...this.state,
          actionCategory: e.target.value,
          actionType: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "Group":
        this.setState({
          ...this.state,
          actionCategory: e.target.value,
          actionType: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "None":
        this.setState({
          ...this.state,
          actionCategory: e.target.value,
          actionType: "",
        });
        this.GetActionTypeListData(e.target.value);
        break;
      case "description":
        this.setState({ ...this.state, description: e.target.value });
        break;
      case "editReferences_Reflink":
        this.setState({
          ...this.state,
          editReferences_Reflink: e.target.value,
        });
        break;
      case "editReferences_Remarks":
        this.setState({
          ...this.state,
          editReferences_Remarks: e.target.value,
        });
        break;
      case "editAttachments_Remarks":
        this.setState({
          ...this.state,
          editAttachments_Remarks: e.target.value,
        });

        break;
      case "Others":
        this.setState({ ...this.state, additionalInformation: e.target.value });
      default:
        break;
    }
  };

  dateJoined = (date) => {
    this.setState({ ...this.state, dateJoined: date });
  };
  lastDayofService = (date) => {
    this.setState({ ...this.state, lastDayofService: date });
  };
  startDate = (date) => {
    this.setState({ ...this.state, startDate: date });
  };
  endDate = (date) => {
    this.setState({ ...this.state, endDate: date });
  };

  handleSelectFormFields = (selectedOption, type) => {
    switch (type) {
      case "requestTypeOptionList":
        this.setState({
          ...this.state,
          eDocType: selectedOption,
        });
        break;
      case "actionTypeOptionList":
        this.setState({ actionType: selectedOption });
        break;
      case "employeeId":
        this.setState({ employeeId: selectedOption });
        break;
      case "positionId":
        this.setState({ positionId: selectedOption });
        break;
      case "salaryGrade":
        this.setState({ salaryGrade: selectedOption });
        break;
      case "workingGroup":
        this.setState({ workingGroup: selectedOption });
        break;
      case "addInfo":
        this.setState({ additionalInformation: selectedOption });
        break;
      case "section":
        this.setState({ section: selectedOption });
        break;
      case "typeOfExit":
        this.setState({ typeOfExit: selectedOption });
        break;
      case "phoneNumber":
        this.setState({ phoneNumber: selectedOption });
        break;
      case "approversection":
        this.setState({ approversection: selectedOption });
        break;
      case "address":
        this.setState({ address: selectedOption });
        break;
      case "companycode":
        this.setState({ companycode: selectedOption });
        break;
      case "divisioncode":
        this.setState({ divisioncode: selectedOption });
        break;
      default:
        break;
    }
  };

  searchEmployee = () => {
    try {
      this.setState({ StaffDetailslistArraySpin: "" });
      let postData = {
        employeeId: this.state.popupEmployeeId,
        name: this.state.popupEmployeeName,
        section: this.state.section.value,
        employeeType: "",
      };
      fetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/StaffInfo", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ StaffDetailslistArray: data.resultObject });
            this.setState({ StaffDetailslistArraySpin: "none" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  approverReferences_Save = (value, type) => {
    try {
      if (
        type == "Delete" || type == "Update"
          ? true
          : this.state.sequence_no && this.state.approverRequesterId
      ) {
        this.setState({ ApproverReferencesLoader: "Yes" });
        let postData = {
          workflowid: type ? value.workflowid : 0,
          referenceno: type ? value.referenceno : this.state.referenceNo,
          sequenceno: type ? value.sequenceno : this.state.sequence_no,
          oriapproverid:
            type == "Delete"
              ? value.oriapproverid
              : this.state.approverRequesterId,
          oriapprovername:
            type == "Delete"
              ? value.oriapprovername
              : this.state.approverRequesterName,
          section:
            type == "Delete"
              ? value.section
              : this.state.approverRequesterSection,
          wfstatus: type ? value.wfstatus : "",
          comments: type ? value.comments : "",
          mode: type ? type : "Add",
          isEdit: type ? value.isEdit : 1,
        };

        fetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/eDoc/InsertUpdateApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                approverEdit: { status: false, value: "" },
                sequence_no: "",
                ApproverReferencesAdd: "none",
                ApproverShowReferenceRequired: "none",
                approverRequesterId: "",
                approverRequesterName: "",
                approverRequesterSection: "",
                approverRequesterSectionName: "",
                approverRequesterDepartment: "",
                approverRequesterDivision: "",
                approverRequesterDesignation: "",
                approverCanStafNamePopover: "flex",
                approverGetEmployeeFirstShow: "",
                approverRequesterDisplayName: "",
                approverpopupEmployeeId: "",
                approverpopupEmployeeName: "",
                approverpopupSection: 0,
                approverStaffDetailslistArray: [],
              });
            }
          })
          .then((data) => {
            fetch(
              process.env.REACT_APP_WEB_SERVICE_URL +
                `/api/eDoc/InsertWorkFlow?ReferenceNo=${this.state.referenceNo}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.props.getToken,
                },
              }
            )
              .then((response) => {
                if (response.status === 200) {
                  return response.json();
                } else if (response.status === 401) {
                  this.props.dispatch({ type: "Referenceno", value: "" });
                  this.props.dispatch({ type: "UserId", value: "" });
                  this.props.dispatch({ type: "profile", value: "" });
                  this.props.dispatch({ type: "headerTitle", value: "" });
                  this.props.dispatch({ type: "Token", value: "" });
                  this.props.dispatch({ type: "userType", value: "" });
                  this.props.dispatch({ type: "userName", value: "" });
                }
              })
              .then((data) => {
                if (data.resultObject) {
                  this.setState({
                    ...this.state,
                    workflowid: data.resultObject,
                    stepbarballon: 2,
                  });
                }
              })
              .catch((error) => {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              });
          })
          .catch((error) => {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          });
      } else {
        this.setState({ errorStatus: true });
      }
    } catch (e) {
      console.log(e);
    }
  };

  addReferences = () => {
    this.setState({ ReferencesAdd: "", showReferenceRequired: "none" });
  };

  addApproverReferences = () => {
    this.setState({
      ApproverReferencesAdd: true,
      ApproverShowReferenceRequired: "none",
      sequence_no: this.state?.workflowid?.length + 1,
    });
  };

  deleteReferences = (id) => {
    this.setState({ referencesdeletePopup: true, referencesdeleteid: id });
  };

  deleteApproverReferences = (id) => {
    this.setState({
      ApproverReferencesdeletePopup: true,
      ApproverReferencesdeleteid: id,
    });
  };

  References_Cancel = () => {
    this.setState({
      ReferencesAdd: "none",
      References_Reflink: "",
      References_Remarks: "",
    });
  };

  editReferencesHide = () => {
    this.setState({ editReferences: false });
  };
  cancelreferencesDelete = () => {
    this.setState({ referencesdeletePopup: false, referencesdeleteid: "" });
  };

  confirmreferencesDelete = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/DeleteReferenceLink?SequenceNo=${parseInt(
            this.state.referencesdeleteid
          )}&referenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              referencesdeleteid: "",
              referencesdeletePopup: false,
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  editReferencesShow = (Sequenceno, Reflink, Remarks) => {
    this.setState({
      editReferences: true,
      editReferences_Sequenceno: Sequenceno,
      editReferences_Reflink: Reflink,
      editReferences_Remarks: Remarks,
    });
  };

  editReferencesHide = () => {
    this.setState({
      editReferences: false,
      editReferences_Reflink: "",
      editReferences_Remarks: "",
    });
  };

  References_Save = () => {
    try {
      this.setState({ ReferencesLoader: "Yes" });
      let postData = {
        sequenceNo: 0,
        referenceNo: this.state.referenceNo,
        reflink: this.state.editReferences_Reflink,
        remarks: this.state.editReferences_Remarks,
      };

      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/InsertReferenceLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              ReferencesAdd: "none",
              showReferenceRequired: "none",
              editReferences: false,
              editReferences_Reflink: "",
              editReferences_Remarks: "",
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  UpdateAttachments = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/UpdateAttachments?ReferenceNo=${
            this.state.referenceNo
          }&SequenceNo=${parseInt(
            this.state.editAttachments_Sequenceno
          )}&Remarks=${this.state.editAttachments_Remarks}`,

        {
          method: "POST",
          processData: false,
          contentType: false,
          crossDomain: true,
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              editAttachments: false,
              editAttachments_Sequenceno: "",
              editAttachments_Filename: "",
              editAttachments_Filetype: "",
              editAttachments_URL: "",
              editAttachments_Remarks: "",
            });
            this.GetAttachmentslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  GetReferenceLinkslistData = (value) => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetReferenceLink?ReferenceNo=${
            value ? value : this.state.referenceNo
          }`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              ReferenceLinkslistArray: data.resultObject,
              ReferencesLoader: "No",
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  UpdateReferences = () => {
    //alert(this.props.Referenceno)
    try {
      let postData = {
        sequenceNo: this.state.editReferences_Sequenceno,
        referenceNo: this.state.referenceNo,
        reflink: this.state.editReferences_Reflink,
        remarks: this.state.editReferences_Remarks,
      };

      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL + "/api/eDoc/UpdateReferenceLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              editReferences: false,
              editReferences_Reflink: "",
              editReferences_Remarks: "",
            });
            this.GetReferenceLinkslistData();
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  saveDraftRequesterInformation = (value) => {
    try {
      if (this.state.eDocType?.id) {
        if (
          this.state.AttachmentslistArray?.length &&
          this.state.eDocType?.value?.includes("Employee Clearance")
            ? this.state.typeOfExit != 0 &&
              this.state.phoneNumber &&
              this.state.address
            : this.state.eDocType?.value == "HRIS"
            ? this.state.actionCategory == "Single"
              ? this.state.actionType &&
                this.state.companycode &&
                this.state.divisioncode &&
                this.state.employeeId &&
                this.state.positionId &&
                this.state.salaryGrade &&
                this.state.workingGroup &&
                this.state.additionalInformation
              : this.state.actionCategory == "Group"
              ? this.state.actionCategory
              : this.state.actionCategory
            : this.state.AttachmentslistArray?.length
        ) {
          let temp = [];
          let temp1 = [];
          this.state.AttachmentslistArray?.map((data) =>
            temp.push({
              sequenceNo: data.sequenceNo,
              referenceNo: data.referenceNo,
              filename: data.filename,
              filetype: data.filetype,
              fileRecord: data.fileRecord,
              remarks: data.remarks,
            })
          );
          this.state.ReferenceLinkslistArray?.map((data) =>
            temp1.push({
              reflink: data.reflink,
              remarks: data.remarks,
            })
          );
          let postData = {
            referenceNo: this.state.referenceNo,
            status: 1,
            requesterId: parseInt(this.state.RequesterId),
            eDocTypeId: this.state.eDocType?.id,
            typeOfExit: this.state.typeOfExit?.id
              ? this.state.typeOfExit?.id
              : 0,
            dateJoined: this.state.dateJoined
              ? this.state.dateJoined
              : new Date(),
            lastDayofService: this.state.lastDayofService
              ? this.state.lastDayofService
              : new Date(),
            phoneNumber: this.state.phoneNumber ? this.state.phoneNumber : "",
            address: this.state.address ? this.state.address : "",
            actionCategory: this.state.actionCategory
              ? this.state.actionCategory
              : "",
            companycode: this.state.companycode?.id
              ? this.state.companycode?.id
              : "",
            divisioncode: this.state.divisioncode?.id
              ? this.state.divisioncode?.id
              : "",
            actionType: this.state.actionType?.id
              ? this.state.actionType?.id
              : 0,
            employeeId: this.state.employeeId
              ? parseInt(this.state.employeeId)
              : 0,
            employeeName: this.state.employeeName
              ? this.state.employeeName
              : "",
            startDate: this.state.startDate ? this.state.startDate : new Date(),
            endDate: this.state.endDate ? this.state.endDate : new Date(),
            positionId: this.state.positionId ? this.state.positionId : "",
            salaryGrade: this.state.salaryGrade ? this.state.salaryGrade : "",
            workingGroup: this.state.workingGroup
              ? this.state.workingGroup
              : "",
            additionalInformation: this.state.additionalInformation,
            description: this.state.description,
            userId: this.props.UserId ? parseInt(this.props.UserId) : 0,
            referenceLinkList:
              temp1?.length > 0
                ? temp1
                : [
                    {
                      reflink: "",
                      remarks: "",
                    },
                  ],
            attachmentList:
              temp?.length > 0
                ? temp
                : [
                    {
                      sequenceNo: 0,
                      referenceNo: "",
                      filename: "",
                      filetype: "",
                      fileRecord: "",
                      remarks: "",
                    },
                  ],
          };
          fetch(
            process.env.REACT_APP_WEB_SERVICE_URL +
              "/api/eDoc/UpdateeDocRequestDetails",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.props.getToken,
              },
              body: JSON.stringify(postData),
            }
          )
            .then((response) => {
              if (response.status === 200) {
                return response.json();
              } else if (response.status === 401) {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              }
            })
            .then((data) => {
              if (data.resultObject) {
                this.props.dispatch({
                  type: "Referenceno",
                  value: data.resultObject,
                });
                this.setState({
                  referenceNo: data.resultObject,
                  isRequesterInformation: "yes",
                });
                if (value == "Next") {
                  fetch(
                    process.env.REACT_APP_WEB_SERVICE_URL +
                      `/api/eDoc/InsertWorkFlow?ReferenceNo=${this.state.referenceNo}`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + this.props.getToken,
                      },
                    }
                  )
                    .then((response) => {
                      if (response.status === 200) {
                        return response.json();
                      } else if (response.status === 401) {
                        this.props.dispatch({ type: "Referenceno", value: "" });
                        this.props.dispatch({ type: "UserId", value: "" });
                        this.props.dispatch({ type: "profile", value: "" });
                        this.props.dispatch({ type: "headerTitle", value: "" });
                        this.props.dispatch({ type: "Token", value: "" });
                        this.props.dispatch({ type: "userType", value: "" });
                        this.props.dispatch({ type: "userName", value: "" });
                      }
                    })
                    .then((data) => {
                      if (data.resultObject) {
                        this.setState({
                          ...this.state,
                          workflowid: data.resultObject,
                          stepbarballon: 2,
                        });
                      }
                    })
                    .catch((error) => {
                      this.props.dispatch({ type: "Referenceno", value: "" });
                      this.props.dispatch({ type: "UserId", value: "" });
                      this.props.dispatch({ type: "profile", value: "" });
                      this.props.dispatch({ type: "headerTitle", value: "" });
                      this.props.dispatch({ type: "Token", value: "" });
                      this.props.dispatch({ type: "userType", value: "" });
                      this.props.dispatch({ type: "userName", value: "" });
                    });
                } else {
                  toast.success("Request successfully saved as a pending.", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                  });
                  this.props.history.push({ pathname: "/dashboard" });
                }
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            });
        } else {
          this.setState({ ...this.state, errorStatus: true });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  saveDraftAuthorizedCarrier = () => {
    try {
      let postData = {
        Referenceno: this.props.Referenceno,
        Authorizedcategory: this.state.Authorizedcategory,
        Authorizedid: this.state.Authorizedid,
        Authorizedname: this.state.Authorizedname,
        Icnumber: this.state.Icnumber,
        Authorizedcompany: this.state.Authorizedcompany,
        Authorizedcompanyaddress: this.state.Authorizedcompanyaddress,
        Vehiclenumber: this.state.Vehiclenumber,
      };
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/GGP/UpdateAuthorizedCarrier",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ isAuthorizedCarrier: "yes" });
            toast.success("Request successfully saved as a pending.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/dashboard" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  formNext = (value) => {
    switch (value) {
      case 1:
        this.saveDraftRequesterInformation("Next");
        break;

      default:
        break;
    }
  };

  formprevious = (value) => {
    switch (value) {
      case 1:
        this.setState({
          step1: "block",
          step2: "none",
          step3: "none",
          step4: "none",
          step5: "none",
          stepbarballon: 1,
        });
        break;

      default:
        break;
    }
  };

  progressSetps = (value) => {
    switch (value) {
      case 1:
        this.setState({
          step1: "block",
          step2: "none",
          step3: "none",
          step4: "none",
          step5: "none",
          stepbarballon: 1,
        });
        break;
      case 2:
        this.saveDraftRequesterInformation("Next");

        break;
      default:
        break;
    }
  };

  onDrop = (acceptedFiles) => {
    try {
      if (this.state.referenceNo) {
        this.setState({
          showAttachedRequired: false,
          AttachmentsLoader: "Yes",
        });
        acceptedFiles?.map((file) => {
          if (file.size > 104857600) {
            toast.info("The maximum file size is 100 MB.");
            this.setState({
              showAttachedRequired: false,
              AttachmentsLoader: "No",
            });
            return;
          }
          let data = new FormData();
          data.append("files", file);
          fetch(
            process.env.REACT_APP_WEB_SERVICE_URL +
              `/api/eDoc/UploadAttachments?ReferenceNo=${
                this.state.referenceNo
              }&UserId=${this.props.UserId}&Remarks=${""}`,
            {
              method: "POST",
              processData: false,
              contentType: false,
              crossDomain: true,
              headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: "Bearer " + this.props.getToken,
              },
              body: data,
            }
          )
            .then((response) => {
              if (response.status === 200) {
                return response.json();
              } else if (response.status === 401) {
                this.props.dispatch({ type: "Referenceno", value: "" });
                this.props.dispatch({ type: "UserId", value: "" });
                this.props.dispatch({ type: "profile", value: "" });
                this.props.dispatch({ type: "headerTitle", value: "" });
                this.props.dispatch({ type: "Token", value: "" });
                this.props.dispatch({ type: "userType", value: "" });
                this.props.dispatch({ type: "userName", value: "" });
              }
            })
            .then((data) => {
              if (data) {
                this.GetAttachmentslistData();
              }
            })
            .catch((error) => {
              this.props.dispatch({ type: "Referenceno", value: "" });
              this.props.dispatch({ type: "UserId", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "headerTitle", value: "" });
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
              this.props.dispatch({ type: "userName", value: "" });
            });
        });
      } else {
        this.setState({
          step1: "block",
          step2: "none",
          step3: "none",
          step4: "none",
          step5: "none",
          stepbarballon: 1,
        });
        if (this.validator1.allValid()) {
        } else {
          this.validator1.showMessages();
          this.forceUpdate();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  companysearchnumb = (val) => {
    this.setState({ SearchCompanyNo: val });
  };
  getVehiclenumber = (val) => {
    this.setState({ Vehiclenumber: val });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchEmployee();
    }
  };

  submitHandler = () => {
    const checkSequence = this.state.eDocType.value.toLowerCase();
    if (
      !checkSequence.includes("hris") &&
      !checkSequence.includes("employee clearance")
    ) {
      let isUnique = true;
      let sequenceSet = new Set();
      this.state?.workflowid?.forEach((obj) => {
        if (sequenceSet.has(obj.sequenceno)) {
          isUnique = false;
        } else {
          sequenceSet.add(obj.sequenceno);
        }
      });
      let sequenceSetArray = [...sequenceSet];
      let largest = Math.max(...sequenceSetArray);
      let i = 1;
      // if (!isUnique) {
      //   toast.info("Sequence Numbers are not in order");
      //   return;
      // }
      while (i <= largest) {
        if (!sequenceSet.has(i) || !isUnique) {
          toast.info("Sequence Numbers are not in order");
          return;
        }
        i += 1;
      }
    }
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/SubmitRequest?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data.resultObject == 0) {
            toast.success("Request successfully created.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            this.props.history.push({ pathname: "/dashboard" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  cancelHandler = () => {
    window.open(process.env.REACT_APP_ENV + "/pending/list", "_self");
  };

  render() {
    let RequestTypeOptionList = [];
    let companyOptionList = [];
    let actionTypeOptionList = [];
    let exitOptionList = [];
    let divisionOptionList = [];
    let SectionTypeOptionList = [];

    if (this.state.CompanylistArray?.length > 0) {
      this.state.CompanylistArray?.map((data) => {
        let sData = {
          id: data.companyNo,
          label: data.companyName,
          value: data.companyNo,
        };
        companyOptionList.push(sData);
        return null;
      });
    }
    if (this.state.sectionListArray?.length > 0) {
      this.state.sectionListArray?.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.code,
        };
        SectionTypeOptionList.push(sData);
        return null;
      });
    }
    if (this.state.exitOptionList?.length > 0) {
      this.state.exitOptionList?.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.description,
        };
        exitOptionList.push(sData);
        return null;
      });
    }
    if (this.state.DivisionListArray?.length > 0) {
      this.state.DivisionListArray?.map((data) => {
        let sData = {
          id: data.code,
          label: data.description,
          value: data.code,
        };
        divisionOptionList.push(sData);
        return null;
      });
    }

    if (this.state.ActionTypelistArray?.length > 0) {
      this.state.ActionTypelistArray?.map((data) => {
        let sData = {
          id: data.id,
          label: data.description,
          value: data.description,
        };
        actionTypeOptionList.push(sData);
        return null;
      });
    }

    if (this.state.RequestlistArray?.length > 0) {
      this.state.RequestlistArray?.map((data) => {
        let sData = {
          id: data.eDocTypeId,
          label: data.eDocType,
          value: data.eDocType,
        };
        RequestTypeOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/pending/list"}>
            Pending : Edit
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit Request</Breadcrumb.Item>
        </Breadcrumb>
        <Modal show={this.state.approverGetEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="approverpopupEmployeeId"
                      value={this.state.approverpopupEmployeeId}
                      onChange={this.handleChange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="approverpopupEmployeeName"
                      value={this.state.approverpopupEmployeeName}
                      onChange={this.handleChange}
                      // onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      value={this.state.approverpopupSection}
                      options={SectionTypeOptionList}
                      onChange={(value) => {
                        this.setState({ approverpopupSection: value });
                      }}
                      // onChange={(value) =>
                      //   this.handleSelectFormFields(value, "approversection")
                      // }

                      // onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.approversearchEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={() => this.approversearchEmployee()}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.approverStaffDetailslistArray?.map((staff) => (
                      <tr
                        className="cursor-pointer"
                        onClick={() =>
                          this.approverGetStaffDetails(
                            staff.employeeId,
                            staff.name,
                            staff.section,
                            staff.sectionName,
                            staff.department,
                            staff.division,
                            staff.designation
                          )
                        }>
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.employeeId} </td>
                        <td> {staff.name} </td>
                        <td> ({staff.account}) </td>
                        <td> {staff.email} </td>
                        <td> {staff.section} </td>
                        <td> {staff.sectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray?.length <= 0 &&
                    this.state.StaffDetailslistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.approverHideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.editReferences} size="lg">
          <Modal.Header>Edit</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Reference Link
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="editReferences_Reflink"
                      value={this.state.editReferences_Reflink}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Remarks
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="editReferences_Remarks"
                      value={this.state.editReferences_Remarks}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.editReferencesHide()}>
                  {" "}
                  Cancel{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.UpdateReferences}>
                  {" "}
                  Update{" "}
                </Button>
              </div>
            </section>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.referencesdeletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button
                className="btn btn-light"
                onClick={this.cancelreferencesDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmreferencesDelete}>
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.getEmployeeFirstShow} size="xl">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      className="form-control"
                      name="popupEmployeeId"
                      value={this.state.popupEmployeeId}
                      onChange={this.handleChange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="popupEmployeeName"
                      value={this.state.popupEmployeeName}
                      onChange={this.handleChange}
                      // onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      value={this.state.section}
                      options={SectionTypeOptionList}
                      onChange={(value) =>
                        this.handleSelectFormFields(value, "section")
                      }
                      // onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>

            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray?.map((staff, index) => (
                      <tr
                        className="cursor-pointer"
                        onClick={() =>
                          this.getStaffDetails(
                            staff.employeeId,
                            staff.name,
                            staff.section,
                            staff.sectionName,
                            staff.department,
                            staff.division,
                            staff.designation
                          )
                        }>
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.employeeId} </td>
                        <td> {staff.name} </td>
                        <td> ({staff.account}) </td>
                        <td> {staff.email} </td>
                        <td> {staff.section} </td>
                        <td> {staff.sectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray?.length <= 0 &&
                    this.state.StaffDetailslistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.StaffDetailslistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.hideFirstStaffPopup()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.attachmentdeletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button
                className="btn btn-light"
                onClick={this.cancelattachmentDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmattachmentDelete}>
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.editAttachments} size="lg">
          <Modal.Header>Edit</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Remarks
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="editAttachments_Remarks"
                      defaultValue={this.state.editAttachments_Remarks}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.editAttachmentsHide()}>
                  {" "}
                  Cancel{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.UpdateAttachments}>
                  {" "}
                  Update{" "}
                </Button>
              </div>
            </section>
          </Modal.Body>
        </Modal>
        <ul id="progressbar">
          <li
            id="req-info"
            className={
              (this.state.stepbarballon === 1 ? "active" : "") +
              (this.state.stepbarballon > 1 ? "selectedBar" : "")
            }
            onClick={() => this.progressSetps(1)}>
            <strong
              className={
                (this.state.stepbarballon === 1 ? "active-text" : "") +
                (this.state.stepbarballon > 1 ? "selected-text" : "")
              }>
              Request Details
            </strong>
          </li>
          <li
            id="auth-career"
            className={
              (this.state.stepbarballon === 2 ? "active" : "") +
              (this.state.stepbarballon > 2 ? "selectedBar" : "")
            }
            onClick={() => this.progressSetps(2)}>
            <strong
              className={
                (this.state.stepbarballon === 2 ? "active-text" : "") +
                (this.state.stepbarballon > 2 ? "selected-text" : "")
              }>
              Approval Flow{" "}
            </strong>
          </li>
        </ul>
        {this.state.stepbarballon === 1 && (
          <>
            <div className="mt-2">
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                Requester Information
                <i
                  className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
            </div>
            <Collapse isOpen={true}>
              <Card>
                <CardBody>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group row">
                        <label
                          for=""
                          className="col-sm-2 col-form-label text-muted">
                          <span style={{ display: "flex" }}>
                            {" "}
                            Staff No / Name{" "}
                            <p style={{ color: "red", marginLeft: 5 }}>
                              *
                            </p>{" "}
                          </span>
                        </label>
                        <div className="col-sm-4">
                          <div className="input-group mb-2 mr-sm-2">
                            <input
                              type="text"
                              className="form-control"
                              id=""
                              placeholder=""
                              readOnly={true}
                              value={this.state.RequesterDisplayName}
                              onClick={this.showFirstStaffPopup}
                            />
                            <div
                              className="input-group-prepend"
                              onClick={this.showFirstStaffPopup}>
                              <div className="input-group-text">
                                <i className="fa fa-search text-muted"> </i>
                              </div>
                            </div>
                            <div
                              className="input-group-prepend ml-3"
                              style={{
                                display: this.state.canStafNamePopover,
                              }}>
                              <button
                                id="PopoverLegacy"
                                className="input-group-text"
                                type="button"
                                data-toggle="popover"
                                data-placement="bottom">
                                <i className="fa fa-info text-muted"> </i>
                              </button>
                            </div>
                          </div>
                          {this.validator1.message(
                            "Staff No / Name",
                            this.state.RequesterDisplayName,
                            "required"
                          )}
                          <UncontrolledPopover
                            trigger="legacy"
                            placement="bottom"
                            target="PopoverLegacy">
                            <PopoverHeader></PopoverHeader>
                            <PopoverBody>
                              <div class="pop">
                                <div class="row">
                                  <div class="col-xs-4 col-md-4">Section</div>
                                  <div class="col-xs-8 col-md-8">
                                    : {this.state.RequesterSection}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4">
                                    Department
                                  </div>
                                  <div class="col-xs-8 col-md-8">
                                    : {this.state.RequesterDepartment}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4">Division</div>
                                  <div class="col-xs-8 col-md-8">
                                    : {this.state.RequesterDivision}
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-4 col-md-4">
                                    Designation
                                  </div>
                                  <div class="col-xs-8 col-md-8">
                                    : {this.state.RequesterDesignation}
                                  </div>
                                </div>
                              </div>
                            </PopoverBody>
                          </UncontrolledPopover>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Collapse>
            <div
              className="mt-2"
              onClick={() =>
                this.setState({ ...this.state, step2: !this.state.step2 })
              }>
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                Request Item Details
                <i
                  className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
            </div>
            <Collapse isOpen={this.state.step2}>
              <Card>
                <CardBody>
                  <div className="row">
                    <div className="col-md-12">
                      <section className="p-2">
                        <div className="form-group row mb-1">
                          <label
                            for="auth-cat"
                            className="col-sm-2 col-form-label text-muted">
                            <span style={{ display: "flex" }}>
                              {" "}
                              eDoc Type
                              <p style={{ color: "red", marginLeft: 5 }}>
                                *
                              </p>{" "}
                            </span>
                          </label>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <Select
                                options={RequestTypeOptionList}
                                onChange={(value) =>
                                  this.handleSelectFormFields(
                                    value,
                                    "requestTypeOptionList"
                                  )
                                }
                                value={this.state.eDocType}
                                // onKeyDown={this._handleKeyDown}
                              />
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                    {this.state.eDocType?.value == "HRIS" && (
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Action Category
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="Single"
                                  value="Single"
                                  checked={
                                    this.state.actionCategory === "Single"
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="form-check-label text-muted"
                                  for="inlineRadio1">
                                  {" "}
                                  Single{" "}
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="Group"
                                  value="Group"
                                  checked={
                                    this.state.actionCategory === "Group"
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="form-check-label text-muted"
                                  for="inlineRadio2">
                                  {" "}
                                  Group{" "}
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="None"
                                  value="None"
                                  checked={
                                    this.state.actionCategory === "None"
                                      ? "checked"
                                      : ""
                                  }
                                  onChange={this.handleChange}
                                />
                                <label
                                  className="form-check-label text-muted"
                                  for="inlineRadio2">
                                  {" "}
                                  None{" "}
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.state.eDocType?.id &&
                            !this.state.actionCategory &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted">
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {this.state.eDocType?.id &&
                                !this.state.actionCategory &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                    )}
                    {this.state.eDocType?.value == "HRIS" && (
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Action Type
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Select
                                  options={actionTypeOptionList}
                                  onChange={(value) =>
                                    this.handleSelectFormFields(
                                      value,
                                      "actionTypeOptionList"
                                    )
                                  }
                                  value={this.state.actionType}
                                  // onKeyDown={this._handleKeyDown}
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.eDocType?.id &&
                            !this.state.actionType &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted">
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {this.state.eDocType?.id &&
                                !this.state.actionType &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                    )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory == "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Company Code
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Select
                                    options={companyOptionList}
                                    onChange={(value) =>
                                      this.handleSelectFormFields(
                                        value,
                                        "companycode"
                                      )
                                    }
                                    value={this.state.companycode}
                                    // onKeyDown={this._handleKeyDown}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.companycode &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.companycode &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Division Code
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Select
                                    options={divisionOptionList}
                                    onChange={(value) =>
                                      this.handleSelectFormFields(
                                        value,
                                        "divisioncode"
                                      )
                                    }
                                    value={this.state.divisioncode}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.divisioncode &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.divisioncode &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory == "None" &&
                      this.state.actionType?.value == "Others" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                {/* <span style={{ display: 'flex' }}>
                                  {' '}
                                  Action Type
                                  <p style={{ color: 'red', marginLeft: 5 }}>
                                    *
                                  </p>{' '}
                                </span> */}
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <textarea
                                    className="form-control"
                                    id=""
                                    rows="4"
                                    name="Others"
                                    value={this.state.additionalInformation}
                                    onChange={this.handleChange}></textarea>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Employee ID / Name
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    type="number"
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "employeeId"
                                      )
                                    }
                                    defaultValue={this.state.employeeId}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.employeeId &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.employeeId &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Position ID
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "positionId"
                                      )
                                    }
                                    defaultValue={this.state.positionId}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.positionId &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.positionId &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Salary Grade
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "salaryGrade"
                                      )
                                    }
                                    defaultValue={this.state.salaryGrade}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.salaryGrade &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.salaryGrade &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Working Group
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "workingGroup"
                                      )
                                    }
                                    defaultValue={this.state.workingGroup}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.workingGroup &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.workingGroup &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Additional Information
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <Input
                                    onChange={(e) =>
                                      this.handleSelectFormFields(
                                        e.target.value,
                                        "addInfo"
                                      )
                                    }
                                    defaultValue={
                                      this.state.additionalInformation
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.eDocType?.id &&
                              !this.state.additionalInformation &&
                              this.state.errorStatus && (
                                <div className="form-group row mb-1 ">
                                  <label
                                    for="auth-cat"
                                    className="col-sm-2 col-form-label text-muted">
                                    {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                  </label>
                                  {this.state.eDocType?.id &&
                                  !this.state.additionalInformation &&
                                  this.state.errorStatus ? (
                                    <div className="col-sm-6">
                                      <div className="form-group">
                                        <p
                                          style={{
                                            fontSize: 13,
                                            color: "red",
                                          }}>
                                          This field is required *
                                        </p>
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )}
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value == "HRIS" &&
                      this.state.actionCategory === "Single" && (
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  Start Date
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>
                              <div className="col-sm-3">
                                <div className="form-group">
                                  <DatePicker
                                    format="dd-MM-y"
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                    clearIcon={null}
                                    onChange={this.startDate}
                                    className="date-picker-style form-control"
                                    value={new Date(this.state.startDate)}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row mb-1">
                              <label
                                for="auth-cat"
                                className="col-sm-2 col-form-label text-muted">
                                <span style={{ display: "flex" }}>
                                  {" "}
                                  End Date
                                  <p style={{ color: "red", marginLeft: 5 }}>
                                    *
                                  </p>{" "}
                                </span>
                              </label>

                              <div className="col-sm-3">
                                <div className="form-group">
                                  <DatePicker
                                    format="dd-MM-y"
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                    }}
                                    clearIcon={null}
                                    onChange={this.endDate}
                                    className="date-picker-style form-control"
                                    value={new Date(this.state.endDate)}
                                  />
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      )}
                    {this.state.eDocType?.value?.includes(
                      "Employee Clearance"
                    ) && (
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Type of Exit
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Select
                                  options={exitOptionList}
                                  onChange={(value) =>
                                    this.handleSelectFormFields(
                                      value,
                                      "typeOfExit"
                                    )
                                  }
                                  value={this.state.typeOfExit}
                                  onKeyDown={this._handleKeyDown}
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.eDocType?.id &&
                            !this.state.typeOfExit &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted">
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {this.state.eDocType?.id &&
                                !this.state.typeOfExit &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                    )}

                    {this.state.eDocType?.value?.includes(
                      "Employee Clearance"
                    ) && (
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Date Joined
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-3">
                              <div className="form-group">
                                <DatePicker
                                  format="dd-MM-y"
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  clearIcon={null}
                                  onChange={this.dateJoined}
                                  className="date-picker-style form-control"
                                  value={new Date(this.state.dateJoined)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Last Day of Service
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>

                            <div className="col-sm-3">
                              <div className="form-group">
                                <DatePicker
                                  format="dd-MM-y"
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  clearIcon={null}
                                  onChange={this.lastDayofService}
                                  className="date-picker-style form-control"
                                  value={new Date(this.state.lastDayofService)}
                                />
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    )}
                    {this.state.eDocType?.value?.includes(
                      "Employee Clearance"
                    ) && (
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-cat"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Phone Number
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    this.handleSelectFormFields(
                                      e.target.value,
                                      "phoneNumber"
                                    )
                                  }
                                  value={this.state.phoneNumber}
                                  defaultValue={this.state.phoneNumber}
                                  onKeyDown={this._handleKeyDown}
                                />
                              </div>
                            </div>
                          </div>
                          {this.state.eDocType?.id &&
                            !this.state.phoneNumber &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted">
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {this.state.eDocType?.id &&
                                !this.state.phoneNumber &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                    )}
                  </div>

                  {this.state.eDocType?.value?.includes(
                    "Employee Clearance"
                  ) && (
                    <div className="row">
                      <div className="col-md-12">
                        <section className="p-2">
                          <div className="form-group row mb-1">
                            <label
                              for="auth-name"
                              className="col-sm-2 col-form-label text-muted">
                              <span style={{ display: "flex" }}>
                                {" "}
                                Address
                                <p style={{ color: "red", marginLeft: 5 }}>
                                  *
                                </p>{" "}
                              </span>
                            </label>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <textarea
                                  className="form-control"
                                  id=""
                                  rows="3"
                                  name="address"
                                  value={this.state.address}
                                  onChange={(e) =>
                                    this.handleSelectFormFields(
                                      e.target.value,
                                      "address"
                                    )
                                  }></textarea>
                              </div>
                            </div>
                          </div>
                          {this.state.eDocType?.id &&
                            !this.state.address &&
                            this.state.errorStatus && (
                              <div className="form-group row mb-1 ">
                                <label
                                  for="auth-cat"
                                  className="col-sm-2 col-form-label text-muted">
                                  {/* <span style={{ display: 'flex' }}>
                              {' '}
                              eDoc Type
                              <p style={{ color: 'red', marginLeft: 5 }}>
                                *
                              </p>{' '}
                            </span> */}
                                </label>
                                {this.state.eDocType?.id &&
                                !this.state.address &&
                                this.state.errorStatus ? (
                                  <div className="col-sm-6">
                                    <div className="form-group">
                                      <p style={{ fontSize: 13, color: "red" }}>
                                        This field is required *
                                      </p>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            )}
                        </section>
                      </div>
                    </div>
                  )}
                  {this.state.actionCategory != "Group" &&
                    this.state.actionCategory != "None" && (
                      <div className="row">
                        <div className="col-md-12">
                          <section className="p-2">
                            <div className="form-group row mb-1">
                              <label
                                for="auth-name"
                                className="col-sm-2 col-form-label text-muted">
                                Description
                              </label>
                              <div className="col-sm-6">
                                <div className="form-group">
                                  <textarea
                                    className="form-control"
                                    id=""
                                    placeholder="Description"
                                    rows="4"
                                    name="description"
                                    defaultValue={
                                      this.state.createDescription
                                        ? this.state.createDescription
                                        : this.state.description
                                    }
                                    onChange={this.handleChange}></textarea>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    )}
                </CardBody>
              </Card>
            </Collapse>
            <div
              className="mt-2"
              onClick={() =>
                this.setState({ ...this.state, step3: !this.state.step3 })
              }>
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                Attachments
                <i
                  className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
            </div>
            <Collapse isOpen={this.state.step3}>
              <Card>
                <CardBody>
                  <div className="row">
                    <div className="col-md-12">
                      <section>
                        <h2 className="fs-title"> </h2>
                        <div>
                          <Dropzone onDrop={this.onDrop}>
                            {({ getRootProps, getInputProps }) => (
                              <div
                                className="jumbotron text-center attachmentStyle"
                                {...getRootProps()}>
                                <input {...getInputProps()} />
                                Drag and drop files , Or click to select
                                attachment files
                              </div>
                            )}
                          </Dropzone>
                        </div>
                        <div className="customized-table">
                          <div className="table-responsive max-height-280">
                            <table className="table table-hover">
                              <thead className="thead-lightBlue">
                                <tr>
                                  <th scope="col"> #</th>
                                  <th scope="col">File name</th>
                                  {/* <th scope="col">File Type</th> */}
                                  <th scope="col">Remarks</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.AttachmentslistArray?.map(
                                  (loopdata, index) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{loopdata.filename}</td>
                                      {/* <td>{loopdata.filetype}</td> */}
                                      <td>{loopdata.remarks}</td>
                                      <td>
                                        <div className="action-icons">
                                          <i
                                            className="fa fa-pencil-square-o text-muted"
                                            aria-hidden="true"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Edit"
                                            onClick={() =>
                                              this.editAttachmentsShow(
                                                loopdata.sequenceNo,
                                                loopdata.remarks
                                              )
                                            }></i>
                                          <i
                                            className="fa fa-trash-o text-muted"
                                            aria-hidden="true"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Delete"
                                            onClick={() =>
                                              this.deleteAttachment(
                                                loopdata.sequenceNo
                                              )
                                            }></i>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                            {(() => {
                              if (
                                this.state.AttachmentslistArray?.length <= 0
                              ) {
                                return (
                                  <div>
                                    <p className="text-center">
                                      No record found.
                                    </p>
                                  </div>
                                );
                              }
                            })()}
                            <p
                              className="text-center"
                              style={{
                                display:
                                  this.state.AttachmentsLoader === "Yes"
                                    ? ""
                                    : "none",
                              }}>
                              <Spinner
                                animation="border"
                                variant="primary"
                                className="text-center"
                              />
                            </p>
                            {this.state.AttachmentslistArray.length <= 0 &&
                              this.state.errorStatus && (
                                <div className="text-danger text-center">
                                  The Attachments is required.
                                </div>
                              )}
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Collapse>
            <div
              className="mt-2"
              onClick={() =>
                this.setState({ ...this.state, step4: !this.state.step4 })
              }>
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                References
                <i
                  className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
            </div>
            <Collapse isOpen={this.state.step4}>
              <Card>
                <CardBody>
                  <div className="row">
                    <div className="col-md-12">
                      <section>
                        <h2 className="fs-title"> </h2>
                        <div className="customized-table">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead className="thead-lightBlue">
                                <tr>
                                  <th scope="col">#</th>
                                  <th scope="col"> Reference Link </th>
                                  <th scope="col"> Remarks </th>
                                  <th scope="col" style={{ float: "right" }}>
                                    Action
                                    <button
                                      className="btn btn-success btn-sm ml-2"
                                      onClick={this.addReferences}>
                                      {" "}
                                      <span className="font-size-17">
                                        +
                                      </span>{" "}
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody
                                style={{
                                  display:
                                    this.state.ReferencesLoader === "Yes"
                                      ? "none"
                                      : "",
                                }}>
                                {this.state.ReferenceLinkslistArray?.map(
                                  (data, index) => (
                                    <tr>
                                      <td>{index + 1}</td>
                                      <td>{data.reflink}</td>
                                      <td>{data.remarks}</td>
                                      <td>
                                        <div className="action-icons">
                                          <i
                                            className="fa fa-pencil-square-o text-muted"
                                            aria-hidden="true"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Edit"
                                            onClick={() =>
                                              this.editReferencesShow(
                                                data.sequenceNo,
                                                data.reflink,
                                                data.remarks
                                              )
                                            }></i>
                                          <i
                                            className="fa fa-trash-o text-muted"
                                            aria-hidden="true"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Delete"
                                            onClick={() =>
                                              this.deleteReferences(
                                                data.sequenceNo
                                              )
                                            }></i>
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}

                                <tr
                                  style={{ display: this.state.ReferencesAdd }}>
                                  <td></td>
                                  <td>
                                    {" "}
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder=""
                                      name="editReferences_Reflink"
                                      value={this.state.editReferences_Reflink}
                                      onChange={this.handleChange}
                                    />{" "}
                                  </td>
                                  <td>
                                    {" "}
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="Enter remarks"
                                      name="editReferences_Remarks"
                                      value={this.state.editReferences_Remarks}
                                      onChange={this.handleChange}
                                    />{" "}
                                  </td>
                                  <td>
                                    <div className="btn-group">
                                      <button
                                        className="btn btn-default btn-md"
                                        type="button"
                                        onClick={this.References_Save}>
                                        {" "}
                                        <i
                                          className="fa fa-floppy-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Save{" "}
                                      </button>
                                      <button
                                        className="btn btn-default btn-md ml-3"
                                        type="button"
                                        onClick={this.References_Cancel}>
                                        {" "}
                                        <i
                                          className="fa fa-trash-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Remove{" "}
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                                <tr
                                  style={{ display: this.state.ReferencesAdd }}>
                                  <td> </td>
                                  <td>
                                    {" "}
                                    {this.validator6.message(
                                      "Qty",
                                      this.state.References_Reflink,
                                      "required"
                                    )}{" "}
                                  </td>
                                  <td>
                                    {" "}
                                    {this.validator6.message(
                                      "Qty",
                                      this.state.References_Remarks,
                                      "required"
                                    )}{" "}
                                  </td>
                                  <td> </td>
                                </tr>
                              </tbody>
                            </table>
                            {(() => {
                              if (
                                this.state.ReferenceLinkslistArray?.length <= 0
                              ) {
                                return (
                                  <div
                                    style={{
                                      display:
                                        this.state.ReferencesAdd === "none"
                                          ? ""
                                          : "none",
                                    }}>
                                    <p className="text-center">
                                      No record found.
                                    </p>
                                  </div>
                                );
                              }
                            })()}
                            <p
                              className="text-center"
                              style={{
                                display:
                                  this.state.ReferencesLoader === "Yes"
                                    ? ""
                                    : "none",
                              }}>
                              <Spinner
                                animation="border"
                                variant="primary"
                                className="text-center"
                              />
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Collapse>
            <div
              className="text-center text-sm-right"
              style={{ marginTop: "25px" }}>
              <button
                className="btn btn-primary-01 ml-3 float-right float-sm-none"
                type="button"
                onClick={() => this.formNext(1)}>
                <span> Next </span>
                <i className="fa fa-angle-right"> </i>{" "}
              </button>
            </div>
          </>
        )}
        {this.state.stepbarballon === 2 && (
          <>
            {" "}
            <h6>Approvers</h6>
            <div
              className="mt-2"
              // onClick={() =>
              //   this.setState({ ...this.state, step4: !this.state.step4 })
              // }
            >
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                Approver Information (Approver Routing must in Sequence)
                <i
                  className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
            </div>
            <Collapse isOpen={true}>
              <Card>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-body">
                      <section>
                        <h2 className="fs-title"> </h2>
                        <div className="customized-table">
                          <div className="table-responsive ">
                            <table className="table table-hover">
                              <thead className="thead-lightBlue">
                                <tr>
                                  <th scope="col" className="text-nowrap">
                                    Sequence No
                                  </th>
                                  <th scope="col" className="text-nowrap">
                                    Approver Name
                                  </th>
                                  <th scope="col" className="text-nowrap">
                                    Section
                                  </th>

                                  {!this.state.eDocType?.value?.includes(
                                    "Employee Clearance"
                                  ) &&
                                    this.state.eDocType?.value != "HRIS" && (
                                      <th
                                        scope="col"
                                        className="text-nowrap float-right">
                                        Action
                                        <button
                                          className="btn btn-success btn-sm ml-2"
                                          onClick={this.addApproverReferences}>
                                          {" "}
                                          <span className="font-size-17">
                                            +
                                          </span>{" "}
                                        </button>
                                      </th>
                                    )}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state?.workflowid?.map((dt, index) => (
                                  <tr className="cursor-pointer">
                                    <td className="text-nowrap">
                                      {dt.sequenceno}
                                    </td>
                                    {this.state.approverEdit?.status &&
                                    this.state.approverEdit?.value == index ? (
                                      <td className="text-nowrap">
                                        <div>
                                          <div className="input-group mb-2 mr-sm-2">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id=""
                                              placeholder=""
                                              readOnly={true}
                                              value={dt.oriapprovername}
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }
                                            />
                                            <div
                                              className="input-group-prepend"
                                              onClick={
                                                this.approverShowFirstStaffPopup
                                              }>
                                              <div className="input-group-text">
                                                <i className="fa fa-search text-muted">
                                                  {" "}
                                                </i>
                                              </div>
                                            </div>
                                            <div
                                              className="input-group-prepend ml-3"
                                              style={{
                                                display:
                                                  this.state
                                                    .approverCanStafNamePopover,
                                              }}>
                                              <button
                                                id="PopoverLegacy"
                                                className="input-group-text"
                                                type="button"
                                                data-toggle="popover"
                                                data-placement="bottom">
                                                <i className="fa fa-info text-muted">
                                                  {" "}
                                                </i>
                                              </button>
                                            </div>
                                          </div>

                                          <UncontrolledPopover
                                            trigger="legacy"
                                            placement="bottom"
                                            target="PopoverLegacy">
                                            <PopoverHeader></PopoverHeader>
                                            <PopoverBody>
                                              <div class="pop">
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Section
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterSection
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Department
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDepartment
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Division
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDivision
                                                    }
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-xs-4 col-md-4">
                                                    Designation
                                                  </div>
                                                  <div class="col-xs-8 col-md-8">
                                                    :{" "}
                                                    {
                                                      this.state
                                                        .approverRequesterDesignation
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            </PopoverBody>
                                          </UncontrolledPopover>
                                        </div>
                                      </td>
                                    ) : (
                                      <td className="text-nowrap">
                                        {`${dt.oriapproverid} / ${dt.oriapprovername}`}
                                      </td>
                                    )}
                                    <td className="mt-3 text-nowrap">
                                      {dt?.section ? dt?.section : " - "}
                                    </td>

                                    <td
                                      style={{ textAlign: "end" }}
                                      className="text-nowrap">
                                      {this.state.approverEdit?.status &&
                                      this.state.approverEdit?.value ==
                                        index ? (
                                        <div className="btn-group">
                                          <button
                                            className="btn btn-default btn-md"
                                            type="button"
                                            onClick={() =>
                                              this.approverReferences_Save(
                                                dt,
                                                "Update"
                                              )
                                            }>
                                            {" "}
                                            <i
                                              className="fa fa-floppy-o text-muted"
                                              aria-hidden="true"></i>{" "}
                                            Save{" "}
                                          </button>
                                          <button
                                            className="btn btn-default btn-md ml-3"
                                            type="button"
                                            onClick={() =>
                                              this.approverReferences_Save(
                                                dt,
                                                "Delete"
                                              )
                                            }>
                                            {" "}
                                            <i
                                              className="fa fa-trash-o text-muted"
                                              aria-hidden="true"></i>{" "}
                                            Remove{" "}
                                          </button>
                                        </div>
                                      ) : dt?.isEdit != 0 ? (
                                        <div className="btn-group">
                                          <button
                                            className="btn btn-default btn-md"
                                            type="button"
                                            onClick={() =>
                                              this.setState({
                                                ...this.state,
                                                approverEdit: {
                                                  status: true,
                                                  value: index,
                                                },
                                              })
                                            }>
                                            Edit{" "}
                                          </button>
                                        </div>
                                      ) : null}
                                    </td>
                                  </tr>
                                ))}
                                <tr
                                  style={{
                                    display: this.state.ApproverReferencesAdd,
                                  }}>
                                  <td className="text-nowrap">
                                    {" "}
                                    <Input
                                      type="number"
                                      name="sequence_no"
                                      value={this.state.sequence_no}
                                      onChange={this.handleChange}
                                    />{" "}
                                    {this.state.errorStatus &&
                                      !this.state.sequence_no && (
                                        <p
                                          style={{
                                            fontSize: 12,
                                            color: "red",
                                          }}>
                                          This field is required
                                        </p>
                                      )}
                                  </td>
                                  <td
                                    style={{ display: "contents" }}
                                    className="text-nowrap">
                                    <td>
                                      <div>
                                        <div className="input-group mb-2 mr-sm-2">
                                          <input
                                            type="text"
                                            className="form-control"
                                            id=""
                                            placeholder=""
                                            readOnly={true}
                                            value={
                                              this.state
                                                .approverRequesterDisplayName
                                            }
                                            onClick={
                                              this.approverShowFirstStaffPopup
                                            }
                                          />

                                          <div
                                            className="input-group-prepend"
                                            onClick={
                                              this.approverShowFirstStaffPopup
                                            }>
                                            <div className="input-group-text">
                                              <i className="fa fa-search text-muted">
                                                {" "}
                                              </i>
                                            </div>
                                          </div>
                                          <div
                                            className="input-group-prepend ml-3"
                                            style={{
                                              display:
                                                this.state
                                                  .approverCanStafNamePopover,
                                            }}>
                                            <button
                                              id="PopoverLegacy"
                                              className="input-group-text"
                                              type="button"
                                              data-toggle="popover"
                                              data-placement="bottom">
                                              <i className="fa fa-info text-muted">
                                                {" "}
                                              </i>
                                            </button>
                                          </div>
                                          {this.state.errorStatus &&
                                            !this.state.approverRequesterId && (
                                              <p
                                                style={{
                                                  fontSize: 12,
                                                  color: "red",
                                                }}>
                                                This field is required
                                              </p>
                                            )}
                                        </div>

                                        <UncontrolledPopover
                                          trigger="legacy"
                                          placement="bottom"
                                          target="PopoverLegacy">
                                          <PopoverHeader></PopoverHeader>
                                          <PopoverBody>
                                            <div class="pop">
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Section
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterSection
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Department
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDepartment
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Division
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDivision
                                                  }
                                                </div>
                                              </div>
                                              <div class="row">
                                                <div class="col-xs-4 col-md-4">
                                                  Designation
                                                </div>
                                                <div class="col-xs-8 col-md-8">
                                                  :{" "}
                                                  {
                                                    this.state
                                                      .approverRequesterDesignation
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </PopoverBody>
                                        </UncontrolledPopover>
                                      </div>
                                    </td>
                                  </td>
                                  <td className="text-nowrap">
                                    {" "}
                                    <input
                                      disabled
                                      className="form-control"
                                      name="editReferences_Remarks"
                                      value={
                                        this.state.approverRequesterSection
                                      }
                                      onChange={this.handleChange}
                                    />{" "}
                                  </td>
                                  <td className="text-nowrap">
                                    <div className="btn-group">
                                      <button
                                        className="btn btn-default btn-md"
                                        type="button"
                                        onClick={this.approverReferences_Save}>
                                        {" "}
                                        <i
                                          className="fa fa-floppy-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Save{" "}
                                      </button>
                                      <button
                                        className="btn btn-default btn-md ml-3"
                                        type="button"
                                        onClick={() =>
                                          this.setState({
                                            approverEdit: {
                                              status: false,
                                              value: "",
                                            },
                                            sequence_no: "",
                                            errorStatus: false,
                                            ApproverReferencesAdd: "none",
                                            ApproverShowReferenceRequired:
                                              "none",
                                            approverRequesterId: "",
                                            approverRequesterName: "",
                                            approverRequesterSection: "",
                                            approverRequesterSectionName: "",
                                            approverRequesterDepartment: "",
                                            approverRequesterDivision: "",
                                            approverRequesterDesignation: "",
                                            approverCanStafNamePopover: "flex",
                                            approverGetEmployeeFirstShow: "",
                                            approverRequesterDisplayName: "",
                                            approverpopupEmployeeId: "",
                                            approverpopupEmployeeName: "",
                                            approverpopupSection: 0,
                                            approverStaffDetailslistArray: [],
                                          })
                                        }>
                                        {" "}
                                        <i
                                          className="fa fa-trash-o text-muted"
                                          aria-hidden="true"></i>{" "}
                                        Remove{" "}
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </Card>
            </Collapse>
            <div className="col-md-12 mt-2">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  className="btn btn-outline-info float-left"
                  type="button"
                  onClick={() => this.formprevious(1)}>
                  <i className="fa fa-angle-left"> </i> <span> Previous </span>
                </button>
                <button
                  className="btn btn-primary-01 ml-3 "
                  type="button"
                  onClick={this.cancelHandler}>
                  <span> Cancel </span>
                </button>
                <button
                  className="btn btn-primary-01 ml-3 "
                  type="button"
                  onClick={this.submitHandler}>
                  Submit
                </button>
              </div>
            </div>
            <div
              className="mt-2"
              // onClick={() =>
              //   this.setState({ ...this.state, step4: !this.state.step4 })
              // }
            >
              <h6 style={{ backgroundColor: "#e9e7e7", padding: "1%" }}>
                Workflow History
                <i
                  // className="fa fa-angle-down text-muted"
                  style={{
                    float: "right",
                    fontSize: "24px",
                  }}></i>
              </h6>
              <div className="card-body">
                <h5 className="card-title text-center">No Records Found</h5>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
    Referenceno: state.Referenceno,
  };
};

export default connect(mapStateToProps)(pendingEdit);
